import { useTranslation } from 'react-i18next';
import type { PageCode } from '@gov-nx/module/page';
import { useEPeticeDetailContext } from '@gov-nx/module/page';
import { Button, ContentLayout, Icon, LayoutGap } from '@gov-nx/ui/web';

interface EPetitionSubmitedStatusBannerProps {
	code: PageCode;
}

export const EPetitionSubmitedStatusBanner = ({
	code,
}: EPetitionSubmitedStatusBannerProps) => {
	const { t } = useTranslation(code);
	const { petition, controls, ePetitionSubmitClose, handleEPetitionDownload } =
		useEPeticeDetailContext();

	return (
		<ContentLayout>
			<LayoutGap gap="l">
				<h2 className="text-headline-s!">{t('pole.zpusob.predani-vyberte')}</h2>
				<div className="flex flex-col gap-(--templates-margin-m) pt-(--spacing-m-nudge) pb-(--spacing-m-nudge) [ md:flex-row ]">
					<Icon
						name="datovka-fill"
						type="templates"
						size="5xl"
						className="text-secondary-600"
					/>
					<div className="flex flex-col gap-(--spacing-xs)">
						<h3 className="text-headline-xs! text-(--text-primary-color)">
							{t('pole.zpusob-podani-datovka')}
						</h3>
						<div>
							<p className="text-(--text-secondary)">
								{t('pole.podani-adresat')}:{' '}
								<strong>{petition?.adresat?.nazev}</strong> (
								{petition?.adresat?.datovaSchrankaId})
							</p>
							<p className="text-(--text-secondary)">
								{t('pole.datovka-popis')}
							</p>
						</div>
					</div>
					<Button
						isDisabled={ePetitionSubmitClose.isSubmited}
						color="primary"
						type="solid"
						size="m"
						aria-label={t('akce.odeslano')}
						className="md:ml-auto!"
						iconStart={
							<Icon
								name="send"
								type="templates"
							/>
						}>
						{t('akce.odeslano')}
					</Button>
				</div>
				<div className="flex flex-col gap-(--templates-margin-m) pt-(--spacing-m-nudge) pb-(--spacing-m-nudge) [ md:flex-row ]">
					<Icon
						name="journal-text"
						type="templates"
						size="5xl"
						className="text-(--text-primary-color)"
					/>
					<div className="flex flex-col gap-(--spacing-xs)">
						<h3 className="text-headline-xs! text-(--text-primary-color)">
							{t('pole.zpusob-podani-osobne')}
						</h3>
						<div>
							<p className="text-(--text-secondary)">
								{t('pole.osobne-popis')}
							</p>
						</div>
					</div>
					<Button
						onClick={() => handleEPetitionDownload()}
						isLoading={controls.isDownloadProcessing ?? false}
						isDisabled={controls.isDownloadProcessing ?? false}
						color="primary"
						type="solid"
						size="m"
						aria-label={t('akce.stahnout')}
						className="md:ml-auto!"
						iconStart={
							<Icon
								name="download"
								type="templates"
							/>
						}>
						{t('akce.stahnout')}
					</Button>
				</div>
			</LayoutGap>
		</ContentLayout>
	);
};
